// cSpell:ignore flexbox, STYuanti, vertical, taotao

import React from 'react';
import styled from 'styled-components';

import RowStar from './lesson-row-star';
import { Flex } from './static/style';
import { Node } from './static/json/constant';

export default class StepNode extends React.Component {

    render() {
        const { activeLocation, text, type, imageUrl, status, star, grapes, locked, index, integral, score } = this.props;

        return (
            <NodeBox locked={locked}
                active={index === activeLocation ? true : false}
                onClick={this.props.onClick}
            >
                <NodeNum
                    active={index === activeLocation ? true : false}>
                    {index}
                </NodeNum>
                <NodePic type={type} image={imageUrl} />
                <NodeText className='lesson-node-text'>{text}</NodeText>

                {/* 下面显示部分的优先级：锁定状态 > 金币（星星、分数、金币）> 已看过 > 未看过 */}
                {locked
                    ? <StatusLocked />
                    : (
                        status
                            ? ((integral || integral === 0)
                                ? <StatusIntegral>{integral}</StatusIntegral>
                                : (star || star === 0)
                                    ? <StatusStar>
                                        <RowStar maxLength={5} star={star} type={Node.node_star} />
                                    </StatusStar>
                                    : (score || score === 0)
                                        ? <StatusScore>{score}分</StatusScore>
                                        : (grapes || grapes === 0)
                                            ? <StatusGrapes>{grapes}</StatusGrapes>
                                            : <StatusRight active={true} />)
                            : <StatusRight active={false} />
                    )
                }
            </NodeBox>
        );
    }
}

const NodeBox = styled.div`
    position: relative;
    width: 3.36rem;
    height: 5.04rem;
    border-radius: 0.72rem;
    margin: 0 0.36rem;
    cursor: pointer;

    ${props => props.locked ?
        `&::after {
            position: absolute;
            display: block;
            content: '';
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            background: rgba(0,0,0,0.2);
            border-radius: 0.72rem;
        }` : ''}

    ${props => props.active ?
        `border: 0.1rem solid #FF802D;
        &::after {
            position: absolute;
            display: block;
            content: '';
            top: 4.38rem;
            left: 2.56rem;
            width: 1.98rem;
            height: 2.66rem;
            background: url(${require('./static/img/taotao.png')}) no-repeat center;
            background-size: contain;
        }
        background: #fff url(${require('./static/img/card-bg-orange.png')}) no-repeat -0.03rem -0.03rem;
        background-size: 1.25rem 0.93rem;
        ` : ` 
        background: #fff url(${require('./static/img/card-bg.png')}) no-repeat left top;
        background-size: 1.25rem 0.93rem;`
    }
`;

const NodeNum = styled.div`
    position: absolute;
    width: 1.25rem;
    height: 0.93rem;
    font-size: 0.45rem;
    font-weight: bold;
    color: #fff;
    line-height: 0.64rem;
    text-align: center;
`;

const NodePic = styled.div`
    margin: 1.05rem auto 0;
    width: 1.92rem;
    height: 1.92rem;
    /* 图片名称相关联值与节点类型 */
    /* background: url(${props => ((props.type === Node.lesson || props.type === Node.summary) && props.image) ? props.image : require(`./static/img/node-${props.type}.png`)}) no-repeat center; */
    background: url(${props => props.image ? props.image : require(`./static/img/node-${props.type}.png`)}) no-repeat center;
    background-size: cover;
    box-sizing: border-box;

    ${props => props.type === Node.lesson ? `
        border: 0.08rem solid rgba(228,252,231,1);
        background-size: cover;
        border-radius: 50%;
    ` : ''}
`;

const NodeText = styled.div`
    text-align: center;
    color: #999;
    line-height: 0.45rem;
    margin: 0.26rem auto 0.45rem;
    font-weight:bold;
    /* font-size: 0.2rem; */
`;

const StatusBox = styled.div`
    height: 0.64rem;
    border-radius: 0.36rem;
    line-height: 0.64rem;
    text-align: center;
    background: #F3F3ED;
    margin: 0 auto;
`;

const StatusRight = styled(StatusBox)`
    position: relative;
    width: 1.57rem;
    background: ${props => props.active ? '#50C841' : '#F3F3ED'} ;

    &::after {
        position: absolute;
        content: '';
        display: block;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        -webkit-transform: translate(-50%, -50%);
        width: 0.38rem;
        height: 0.29rem;
        background: url(${require('./static/img/right-bg.png')}) no-repeat center;
        background-size: contain;
    }
`;

const StatusStar = styled(StatusBox)`
    width: 2.72rem;
    padding: 0.1rem 0.26rem;
`;

const StatusScore = styled(StatusBox)`
    background: #50C841;
    width: 1.57rem;
    color: #fff;
    font-size: 0.32rem;
`;

const StatusGrapes = styled(StatusBox)`
    width: 1.57rem;
    padding-left: 0.3rem;
    background: #F3F3ED url(${require('./static/img/grape.png')}) no-repeat 0.24rem 0.1rem;
    background-size: 0.42rem;
    color: #999999;
    font-weight: bold;
    font-size: 0.32rem;
`;

const StatusIntegral = styled(StatusGrapes)`
    background: #F3F3ED url('https://webres.putaoabc.com/course/images/medal/score_icon.png') no-repeat 0.24rem 0.1rem;
    background-size: 0.42rem;
`;

const StatusLocked = styled.div`
    position: relative;
    width: 0.58rem;
    height: 0.58rem;
    background: url(${require('./static/img/lock.png')}) no-repeat center;
    background-size: contain;
    margin: 0 auto;
    z-index: 10;
`;


// WEBPACK FOOTER //
// ./src/lib/components/LessonPath/step-node.js